// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Account, Concept, User, CardCode, SocialLink, Feature, Language, Media, Attachment, Group, GroupSetting, Timeline, AdminRole, AdminGroup, UserConcepts, Point, Tier, Transaction, OrderedItems, TransactionItem } = initSchema(schema);

export {
  Account,
  Concept,
  User,
  CardCode,
  SocialLink,
  Feature,
  Language,
  Media,
  Attachment,
  Group,
  GroupSetting,
  Timeline,
  AdminRole,
  AdminGroup,
  UserConcepts,
  Point,
  Tier,
  Transaction,
  OrderedItems,
  TransactionItem
};